import { Injectable } from "@angular/core";
import { CONSTANTS } from "app/constants";
import { Observable } from "rxjs";
import { ConfigurationService, HttpService } from ".";
import { BanDto, PlayerDto, PlayerShortDto, PlayerTrainingResultDto, TacticPlayerDto } from "../models/dtos";
import { BaseService } from "./base.service";

@Injectable()
export class PlayerService extends BaseService {
    
    constructor(httpService: HttpService,
        configurationService: ConfigurationService) {
            super(httpService, configurationService);
    }

    findByTeam(teamId: number): Observable<PlayerDto[]> {
        return this.httpService.get<PlayerDto[]>(this.apiUrl + 'teams/' + teamId + "/players", null)
    }

    formatPlayerPosition(player: PlayerDto): string {
        if (!player)
            return null;

        if (player.isGK)
            return CONSTANTS.playerPositionNames.GK;
        
        let sides = [];

        if (player.isLeft) {
            sides.push(CONSTANTS.playerSideNames.L);
        }

        if (player.isCenter) {
            sides.push(CONSTANTS.playerSideNames.C);
        }

        if (player.isRight) {
            sides.push(CONSTANTS.playerSideNames.R);
        }

        let positions = [];

        if (player.isSW) {
            positions.push(CONSTANTS.playerPositionNames.SW);
        }

        if (player.isDF) {
            positions.push(CONSTANTS.playerPositionNames.DF);
        }

        if (player.isDM) {
            positions.push(CONSTANTS.playerPositionNames.DM);
        }

        if (player.isMF) {
            positions.push(CONSTANTS.playerPositionNames.MF);
        }

        if (player.isAM) {
            positions.push(CONSTANTS.playerPositionNames.AM);
        }

        if (player.isFW) {
            positions.push(CONSTANTS.playerPositionNames.FW);
        }

        return sides.join("/") + " " + positions.join("/");
    }

    sortPlayersByPosition(players: PlayerDto[]): PlayerDto[] {

        var result = [];

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {
            if (this.getPositionNumberValue(a) === this.getPositionNumberValue(b)) {
                return 0;
            }

            return this.getPositionNumberValue(a) > this.getPositionNumberValue(b) ? 1 : -11
        })

        return result;
    }

    sortTacticPlayersByPosition(tacticPlayers: TacticPlayerDto[], squad: PlayerDto[]): PlayerDto[] {

        let tempSquad = tacticPlayers.sort((a, b) => {
            const posA = a.position * 10 + a.side;
            const posB = b.position * 10 + b.side;
            if (posA < posB) {
              return -1;
            }
            if (posA > posB) {
              return 1;
            }
            return 0;
          });
        
        var result = [];
        
        tempSquad.forEach(item => {
            result.push(squad.find(p => p.id == item.playerId));
        });

        return result;
    }

    sortRosterPlayersByPosition(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (this.getPositionNumberValue(a) + this.getLoanCoef(a, currTeamId, sortCoef) === this.getPositionNumberValue(b) + this.getLoanCoef(b, currTeamId, sortCoef)) {
                return 0;
            }

            return this.getPositionNumberValue(a) + this.getLoanCoef(a, currTeamId, sortCoef) > this.getPositionNumberValue(b) + this.getLoanCoef(b, currTeamId, sortCoef) ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByAge(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.age === b.age) {
                return 0;
            }

            return a.age > b.age ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByPhys(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            let pl1 = a.form + a.injuryLength * (-100);
            let pl2 = b.form + b.injuryLength * (-100);

            if (pl1 === pl2) {
                return 0;
            }

            return pl1 > pl2 ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByMorale(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.morale === b.morale) {
                return 0;
            }

            return a.morale > b.morale ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByPower(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.power === b.power) {
                return 0;
            }

            return a.power > b.power ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByCost(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.cost === b.cost) {
                return 0;
            }

            return a.cost > b.cost ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByWage(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.salary === b.salary) {
                return 0;
            }

            return a.salary > b.salary ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByContractLength(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.contractLength === b.contractLength) {
                return 0;
            }

            return a.contractLength > b.contractLength ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByStamina(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.skills.stamina === b.skills.stamina) {
                return 0;
            }

            return a.skills.stamina > b.skills.stamina ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByForce(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.skills.force === b.skills.force) {
                return 0;
            }

            return a.skills.force > b.skills.force ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersBySpeed(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.skills.speed === b.skills.speed) {
                return 0;
            }

            return a.skills.speed > b.skills.speed ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByLeadership(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.skills.leadership === b.skills.leadership) {
                return 0;
            }

            return a.skills.leadership > b.skills.leadership ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByDribbling(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.skills.dribbling === b.skills.dribbling) {
                return 0;
            }

            return a.skills.dribbling > b.skills.dribbling ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByTechnique(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.skills.tecnique === b.skills.tecnique) {
                return 0;
            }

            return a.skills.tecnique > b.skills.tecnique ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByPowerShot(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.skills.powerShoot === b.skills.powerShoot) {
                return 0;
            }

            return a.skills.powerShoot > b.skills.powerShoot ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByAccuracyShot(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.skills.accuracyShoot === b.skills.accuracyShoot) {
                return 0;
            }

            return a.skills.accuracyShoot > b.skills.accuracyShoot ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByFreeKick(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.skills.freeKick === b.skills.freeKick) {
                return 0;
            }

            return a.skills.freeKick > b.skills.freeKick ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByCornerKick(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.skills.cornerKick === b.skills.cornerKick) {
                return 0;
            }

            return a.skills.cornerKick > b.skills.cornerKick ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByName(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.name + a.surname === b.name + b.surname) {
                return 0;
            }

            return a.name + a.surname > b.name + b.surname ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByVision(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.skills.vision === b.skills.vision) {
                return 0;
            }

            return a.skills.vision > b.skills.vision  ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByPositioning(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.skills.positioning === b.skills.positioning) {
                return 0;
            }

            return a.skills.positioning > b.skills.positioning  ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByHead(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.isGK) {
                if (a.skills.gkThrowing === b.skills.gkThrowing) {
                    return 0;
                }
    
                return a.skills.gkThrowing > b.skills.gkThrowing  ? 1 * sortCoef : (-1) * sortCoef
            } 

            if (a.skills.heading === b.skills.heading) {
                return 0;
            }

            return a.skills.heading > b.skills.heading  ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByTackling(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.isGK) {
                if (a.skills.gkOutPlaying === b.skills.gkOutPlaying) {
                    return 0;
                }
    
                return a.skills.gkOutPlaying > b.skills.gkOutPlaying  ? 1 * sortCoef : (-1) * sortCoef
            } 

            if (a.skills.tackling === b.skills.tackling) {
                return 0;
            }

            return a.skills.tackling > b.skills.tackling  ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByCross(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.isGK) {
                if (a.skills.gkHanding === b.skills.gkHanding) {
                    return 0;
                }
    
                return a.skills.gkHanding > b.skills.gkHanding  ? 1 * sortCoef : (-1) * sortCoef
            } 

            if (a.skills.crossing === b.skills.crossing) {
                return 0;
            }

            return a.skills.crossing > b.skills.crossing  ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    sortPlayersByPass(players: PlayerDto[], currTeamId: number, sortDirection: number): PlayerDto[] {

        var result = [];

        let sortCoef = sortDirection === CONSTANTS.sortDirection.asc ? 1 : -1;

        players.forEach(item => {
            result.push(item);
        });

        result.sort((a, b) => {

            if (a.isGK) {
                if (a.skills.gkReaction === b.skills.gkReaction) {
                    return 0;
                }
    
                return a.skills.gkReaction > b.skills.gkReaction  ? 1 * sortCoef : (-1) * sortCoef
            } 


            if (a.skills.passing === b.skills.passing) {
                return 0;
            }

            return a.skills.passing > b.skills.passing  ? 1 * sortCoef : (-1) * sortCoef
        })

        return result;
    }

    findFoRoster(teamId: number): Observable<PlayerShortDto[]> {
        return this.httpService.get<PlayerShortDto[]>(this.apiUrl + 'teams/' + teamId + "/roster", null);
    }

    getTainingReports(teamId: number): Observable<PlayerTrainingResultDto[]> {
        return this.httpService.get<PlayerTrainingResultDto[]>(this.apiUrl + 'teams/' + teamId + "/training-result", null);
    }

    getLatestGraduates(teamId: number): Observable<number[]> {
        return this.httpService.get<number[]>(this.apiUrl + 'teams/' + teamId + "/last-graduates", null);
    }

    formatPlayerCost(cost: number): string {
        if (cost > 1000000) {
            cost = cost / 1000000;
            cost = Math.round(cost * 100) / 100;
            return cost + "M €";
        }

        if (cost > 10000) {
            cost = cost / 1000;
            cost = Math.round(cost * 100) / 100;
            return cost + "K €";
        }

        return cost+ "K €";
    }

    getBansForTeam(teamId: number): Observable<BanDto[]> {
        return this.httpService.get<BanDto[]>(this.apiUrl + 'teams/' + teamId + "/bans", null);
    }

    private getPositionNumberValue(pl: PlayerDto) : number {

        let res = 0;

        if (pl.isGK)
            return 1;

        if (pl.isSW) {
            res += 10 + this.getSideNumberValue(pl);
            return res;
        }

        if (pl.isDF){
            res += 20 + this.getSideNumberValue(pl);
            return res;
        }

        if (pl.isDM){
            res += 40 + this.getSideNumberValue(pl);
            return res;
        }

        if (pl.isMF){
            res += 80 + this.getSideNumberValue(pl);
            return res;
        }

        if (pl.isAM){
            res += 160 + this.getSideNumberValue(pl);
            return res;
        }

        if (pl.isFW){
            res += 320 + this.getSideNumberValue(pl);
            return res;
        }

        

        return res;
    }

    private getSideNumberValue(pl: PlayerDto): number {
        let result = 0;
        
        if (pl.isLeft)
            result += 1;

        if (pl.isCenter)
            result += 2;

        if (pl.isRight && pl.isCenter)
            result += 3;

        if (pl.isRight && !pl.isCenter)
            result += 5;

        return result;
    }

    private getLoanCoef(pl: PlayerShortDto, currTeamId: number, sortCoef: number): number {
        let coef = sortCoef === CONSTANTS.sortDirection.asc ? 1 : -1;
        
        return (pl.teamId != currTeamId) ? 1000 * coef : 0;
    }
}